module.exports = __webpack_public_path__ + "static/media/covi_mee_red_mee_att.e0e90a42.png";